// La tarjeta de un agente (nombre, frase, «Abrir chat») es un ESTADO, no un :hover/:focus-within (Pau 28-09: «el
// cuadradito de abrir el chat se queda bloqueado»): con :focus-within el foco se quedaba dentro al pulsar y la tarjeta
// seguía encima del chat ya abierto. Se abre al pasar el ratón (con un respiro), aguanta mientras el ratón va de la mesa
// a la tarjeta y se cierra al pulsar. Cerrada no se pinta: nada invisible queda tapando la oficina.
import { useEffect, useMemo, useRef, useState } from 'react';

export function useTarjeta() {
  const [abierta, setAbierta] = useState<string | null>(null);
  const reloj = useRef<ReturnType<typeof setTimeout>>();
  useEffect(() => () => clearTimeout(reloj.current), []);
  const acciones = useMemo(
    () => ({
      /** Abre (id) o cierra (null) la tarjeta dentro de `ms`, anulando lo que hubiera pendiente. */
      programar: (id: string | null, ms: number) => {
        clearTimeout(reloj.current);
        reloj.current = setTimeout(() => setAbierta(id), ms);
      },
      cerrar: () => {
        clearTimeout(reloj.current);
        setAbierta(null);
      },
      /** Ya (foco del teclado). */
      mostrar: (id: string) => setAbierta(id),
      /** Anula el cierre pendiente (el foco entró en la tarjeta). */
      retener: () => clearTimeout(reloj.current),
    }),
    [],
  );
  return { abierta, ...acciones };
}
